<template>
    <common-page flex-column>
        <div class="card">
            <div class="d-flex flex-row align-items-center m-1">
                <el-tooltip effect="dark" content="开始时间" placement="top">
                    <el-date-picker
                        v-model="fromDate"
                        type="date"
                        placeholder="开始日期"
                        @change="dateChange"
                        :disabled="loading">
                    </el-date-picker>
                </el-tooltip>
                <i class="el-icon-minus"></i>
                <el-tooltip effect="dark" content="目标时间" placement="top">
                    <el-date-picker
                        v-model="toDate"
                        align="right"
                        type="date"
                        placeholder="选择目标日期"
                        :disabled="loading"
                        @change="dateChange">
                    </el-date-picker>
                </el-tooltip>
                <div class="ml-auto d-flex flex-row">
                    <b-button v-if="headerChangedResultOverView" variant="light"
                              class="mr-2"
                              @click="$refs.changeDetail.showModal()">
                        <i class="fa-solid fa-info"></i>
                    </b-button>
                    <AvatarButton class="mr-2"
                                  icon="el-icon-s-promotion" @btnClick="getRemoteSchedulingResult"
                                  :loading="scheduleLoading"
                                  title="重新排产"></AvatarButton>
                    <AvatarButton icon="el-icon-search"
                                  class="mr-2"
                                  @btnClick="$refs.allHeaderModal.showModal()"
                                  title="全局工单搜索"></AvatarButton>
                    <AvatarButton icon="el-icon-date"
                                  class="mr-2"
                                  corner-icon="fa-check-circle"
                                  :show-corner="calendarManagement"
                                  @btnClick="$store.commit('calendarShift/setCalendarManagement',!calendarManagement)"
                                  title="日历维护：加班"></AvatarButton>
                    <AvatarButton icon="el-icon-s-unfold"
                                  class="mr-2"
                                  corner-icon="fa-check-circle"
                                  :show-corner="addShiftRule"
                                  @btnClick="$store.commit('calendarShift/setAddShiftRule',!addShiftRule)"
                                  title="工厂排班"></AvatarButton>
                    <button type="button" class="btn mr-2"
                            :class="displayJoinHeader ? 'btn-warning' : 'btn-outline-warning'"
                            data-toggle="tooltip"
                            title="切换新排入工单的显示"
                            v-if="showSaveBtn && displayJoinHeader!=null"
                            @click="$store.commit('calendarShift/setDisplayJoinHeader',!displayJoinHeader)">
                        <i class="fa fa-bolt" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-outline-info btn-color" @click="$router.go(-1)">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        返回
                    </button>
                    <b-overlay :show="scheduledResultSaving" spinner-variant="primary"
                               spinner-type="grow" spinner-small>
                        <button type="button" class="btn btn-outline-info btn-color"
                                v-if="showSaveBtn"
                                @click="$refs.scheduledSave.showModal()">
                            <i class="fa fa-save" aria-hidden="true"></i>
                            保存
                        </button>
                    </b-overlay>
                </div>

            </div>
        </div>

        <div class="ml-0 display-box" style="height: calc(100vh - 178px)">
            <div class="col h-100" :class="itemPos != null && !itemOff ? 'item-open' : 'item-close'">
                <div class="row item-cover">
                    <LoadRateItem v-if="itemPos != null" @needRefresh="getRemoteSchedulingResult"></LoadRateItem>
                </div>
                <div class="row mt-2 mh-100 trh">
                    <DrawerHandler is-left :close-width="4.5" v-if="locationIdList.length > 0">
                        <div class="col-2 mh-100" style="max-width: 300px">
                            <LoadRateActiveLocationList
                                ref="locationList"
                                @activeChange="activeChange"
                                :location-id-list="locationIdList">
                            </LoadRateActiveLocationList>
                        </div>
                    </DrawerHandler>
                    <div class="col card ml-2 mh-100">
                        <LoadRateMatrix
                            ref="loadRateMatrix"
                            class="m-auto"
                            style="z-index: 999"
                            :headers="dateStrList"
                            :side_locations="locationIdActiveList"
                            :main_data="remoteData"
                            v-if="matrixLazyLoad">
                        </LoadRateMatrix>
                    </div>
                </div>
            </div>
            <div class="mt-2 col-auto h-100 bg-normal">
                <LoadRateHeaderList ref="headerList" :pp_header_ids="ppHeaderIdList"
                                    v-if="headerListLazyLoad"></LoadRateHeaderList>
            </div>
        </div>

        <div class="cover" v-if="displayMode===3" @click="coverClick"/>
        <div class="spinner-border loading" role="status" v-if="scheduleLoading">
            <span class="sr-only">Loading...</span>
        </div>

        <ReBModal header="全局工单列表" ref="allHeaderModal" class="h-100">
            <LoadRateHeaderList is-modal></LoadRateHeaderList>
        </ReBModal>

        <ReBModal header="保存排产结果" ref="scheduledSave"
                  no-auto-hide
                  :ok-loading="scheduledResultSaving"
                  @ok="saveScheduledResult">
            <!--            <diverse-input :value.sync="saveReason" :config="saveReasonConfig"></diverse-input>-->
            <diverse-input-group ref="scheduleSaveForm"
                                 :configs="saveReasonConfig"></diverse-input-group>
        </ReBModal>

        <ReBModal header="排产变化概览" ref="changeDetail" superLarge fit-content hide-footer>
            <!--            <div style="white-space: pre;">{{ headerChangedResultOverView }}</div>-->
            <mini-table :items="headerChangedResultOverView"
                        :fields="tableFields"
                        disable-first-index-column
                        filterable
                        auto-page-view
                        default-page-size="100"
                        read-only>
            </mini-table>
        </ReBModal>
    </common-page>
</template>

<script>
import LoadRateMatrix from "@/components/echarts-part/CalendarShift/cells/LoadRateMatrix";
import LoadRateHeaderList from "@/components/echarts-part/CalendarShift/cells/LoadRateHeaderList";
import LoadRateItem from "@/components/echarts-part/CalendarShift/cells/LoadRateItem";
import {subMapOf} from "@/components/echarts-part/CalendarShift/cells/utils/LoadRateUtil";
import moment from "moment";
import LoadRateActiveLocationList from "@/components/echarts-part/CalendarShift/cells/LoadRateActiveLocationList";
import {mapState} from "vuex";
import EmCommonApi from "@/mixin/em/common/api";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import emCommonListMixin from "@/mixin/em/common/list";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import _ from "lodash";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup.vue";

export default {
    name: "LoadRatePage",
    components: {
        DiverseInputGroup,
        MiniTable,
        DiverseInput,
        CommonPage,
        ReBModal,
        AvatarButton,
        DrawerHandler,
        LoadRateHeaderList,
        LoadRateActiveLocationList,
        LoadRateItem,
        LoadRateMatrix
    },
    mixins: [EmCommonApi, emCommonListMixin],
    watch: {
        locationIdList: {
            deep: true,
            handler() {
                let tempList = [];
                for (let item of this.locationIdList) {
                    if (item.active) {
                        tempList.push({
                            id: item.id,
                            label: item.label
                        });
                    }
                }
                this.locationIdActiveList = tempList;
                if (this.showLocationIdSet == null) {
                    this.collectPpHeaderId();
                }
            }
        },
        itemOff(val) {
            if (val) {
                setTimeout(() => {
                    this.$store.commit('calendarShift/setItemPos', null);
                    this.$store.commit('calendarShift/setItemOff', false);
                }, 380);
            }
        },
        forceScroll(val) {
            if (val && this.selectedOperationId !== null) {
                let operation = this.operationMap[this.selectedOperationId];
                let beginTime = new Date(operation.forecastBeginTime);
                let finishTime = new Date(operation.forecastFinishTime);
                if (this.toDate < finishTime) {
                    this.toDate = finishTime;
                } else if (this.fromDate > beginTime) {
                    this.fromDate = beginTime;
                }
                let locationId = operation.actualMstLocationId + '';
                let hasActive = false;
                for (let item of this.locationIdActiveList) {
                    if (item.id === locationId) {
                        hasActive = true;
                        break;
                    }
                }
                if (!hasActive) {
                    this.$refs.locationList.switchLocation(locationId);
                }
                this.dateChange();
                setTimeout(() => {
                    this.$store.commit('calendarShift/setNeedScroll', true);
                    this.$store.commit('calendarShift/setForceScroll', false);
                }, 500);
            }
        },
        headerListTempLock(val, old) {
            if (!val && old) {
                this.collectPpHeaderId();
                this.$refs.headerList.searchInput = '';
            }
        }
    },
    computed: {
        ...mapState({
            loading: state => state.calendarShift.loading,
            displayMode: state => state.calendarShift.displayMode,
            itemPos: state => state.calendarShift.itemPos,
            dataIsSet: state => state.calendarShift.dataIsSet,
            itemOff: state => state.calendarShift.itemOff,
            forceScroll: state => state.calendarShift.forceScroll,
            selectedOperationId: state => state.calendarShift.selectedOperationId,
            displayJoinHeader: state => state.calendarShift.displayJoinHeader,
            showLocationIdSet: state => state.calendarShift.showLocationIdSet,
            headerListTempLock: state => state.calendarShift.headerListTempLock,
            schedulingForm: state => state.calendarShift.schedulingForm,
            calendarManagement: state => state.calendarShift.calendarManagement,
            addShiftRule: state => state.calendarShift.addShiftRule,
        }),
        remoteData() {
            return this.$store.getters["calendarShift/scheduledData"];
        },
        headerMap() {
            return this.$store.getters["calendarShift/headerMap"];
        },
        operationMap() {
            return this.$store.getters["calendarShift/operationMap"];
        },
        headerChangedResultOverView() {
            return this.$store.getters["calendarShift/headerChangedResultOverView"];
        },
    },
    data() {
        return {
            fromDate: new Date(),
            toDate: '',
            locationIdList: [],
            locationIdActiveList: [],
            dateStrList: [],
            ppHeaderIdList: [],
            matrixLazyLoad: false,
            headerListLazyLoad: false,

            scheduleLoading: false,
            scheduledResultSaving: false,
            saveReason: '',
            saveReasonConfig: [
                {
                    label: "调整原因类别",
                    name: "adjustType",
                    type: "select",
                    optionsFromDict: 'pp_header_schedule_reason_type',
                    require: true
                },
                {label: "调整原因描述", name: "adjustReason", type: "textarea", require: true},
                {label: "项目号", name: "adjustCauseProjectCode", type: "input", require: true},
                {label: '备注说明', name: 'remark', type: 'textarea'}
            ],
            showSaveBtn: false,
            tableFields: [
                {key: 'no', label: '序号'},
                {key: 'headerCode', label: '工单'},
                {key: 'headerStatus', label: '工单状态'},
                {key: 'priority', label: '优先级', format: 'number'},
                {key: 'totalWorkHour', label: '总工时', format: 'number'},
                {key: 'changeType', label: '变化类型'},
                {key: 'deliveryChange', label: '交期变化'},
                {key: 'durationChange', label: '加工周期变化'},
                {key: 'afterEndTime', label: '新交期'},
                {key: 'beforeEndTime', label: '原交期'},
                {key: 'afterDuration', label: '新加工周期'},
                {key: 'beforeDuration', label: '原加工周期'},
            ]
        };
    },
    created() {
        if (this.$route.query.showSave !== undefined) {
            this.showSaveBtn = true;
        }
    },
    mounted() {
        if (!this.dataIsSet) {
            // this.route2HeaderList(false);
            this.getRemoteSchedulingResult();
        } else {
            this.initData();
        }
        this.getRemoteMstLocations();
        this.initVuex();
    },
    methods: {
        initVuex() {
            this.$store.commit('calendarShift/setShowLocationIdSet', null);
            this.$store.commit('calendarShift/setHeaderListTempLock', false);
        },
        initData() {
            let data = this.remoteData;
            let locationIdList = [];

            for (let location in data) {
                if (data.hasOwnProperty(location)) {
                    let active = false;
                    let overFlow = false;
                    let locationInfo = data[location];
                    let dayMap = subMapOf(locationInfo);
                    for (let dateStr in dayMap) {
                        if (dayMap.hasOwnProperty(dateStr)) {
                            let dayOfMap = dayMap[dateStr];
                            //计算是否标红
                            if (new Date(Date.parse(dayOfMap.startDate)) >= new Date() && !overFlow && dayOfMap.workingHoursAbility < dayOfMap.workingHoursActual) {
                                overFlow = true;
                            }
                            let ops = dayOfMap.operationSchedulePosVoMap;
                            if (!active && ops !== undefined && Object.keys(ops).length > 0) {
                                active = true;
                            }
                        }
                    }
                    locationIdList.push({
                        id: location,
                        label: locationInfo.workStationName + '-' + locationInfo.workCenterName,
                        active: active,
                        overFlow: overFlow,
                        show: true
                    });
                }
            }
            this.locationIdList = _.orderBy(locationIdList, ['label'], ['asc']);
            if (this.toDate === '') {
                this.toDate = this.getDaysLater(30);
                this.dateChange();
            }
            this.matrixLazyLoad = true;
        },
        collectPpHeaderId() {
            if (this.headerListTempLock) {
                return;
            }
            let tempSet = new Set();
            for (let locationId of this.locationIdActiveList) {
                let dayMap = subMapOf(this.remoteData[locationId.id]);
                for (let dateStr in dayMap) {
                    //增加日期限制
                    if (dayMap.hasOwnProperty(dateStr) && dateStr <= this.formatDate(this.toDate) && dateStr >= this.formatDate(this.fromDate)) {
                        let posMap = subMapOf(dayMap[dateStr]);
                        for (let pos in posMap) {
                            if (posMap.hasOwnProperty(pos)) {
                                let id = posMap[pos].headerId;
                                if (this.headerMap.hasOwnProperty(id)) {
                                    tempSet.add(id);
                                }
                            }
                        }
                    }
                }
            }
            this.ppHeaderIdList = Array.from(tempSet);
            this.headerListLazyLoad = true;
        },
        splitDate(fromDate, toDate) {
            let dates = [];
            let tempDate = new Date(fromDate);
            while (tempDate <= toDate) {
                dates.push(this.formatDate(tempDate));
                tempDate.setDate(tempDate.getDate() + 1);
            }
            if (dates.length <= 0) {
                this.$message.warning('开始时间需在目标时间之前')
            }
            return dates;
        },
        formatDate(date) {
            return moment(date).format(
                this.$t("em.date.format.viewMode")
            );
        },
        coverClick() {
            this.$store.commit('calendarShift/setDisplayMode', 0);
        },
        activeChange(item) {
            this.$refs.loadRateMatrix.changeSideLocation(item);
        },
        getDaysLater(day_num) {
            let date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * day_num);
            return date
        },
        dateChange() {
            this.dateStrList = this.splitDate(this.fromDate, this.toDate);
            if (this.matrixLazyLoad) {
                setTimeout(() => {
                    this.$refs.loadRateMatrix.observeLazyLoad();
                }, 500)
            }
            this.collectPpHeaderId();
        },
        route2HeaderList(save) {
            if (save !== undefined && save) {
                this.$store.commit('calendarShift/setSaveResult', true);
            }
            this.$router.push('/sithMes/prd/sithMesPrdPpHeaderList');
        },

        getRemoteMstLocations() {
            let _api = this.$store.state.sithMesMstLocation.baseModuleUrl + '/sithMesMstLocation/loadRate/mstLocations';
            this.$_emApiMixin_get(_api).then(value => {
                this.$store.commit('calendarShift/setLocationList', value);
            });
        },

        getRemoteSchedulingResult() {
            this.scheduleLoading = true;
            let _api = this.$store.state.sithMesPrdPpHeader.baseModuleUrl + '/sithMesPrdPpHeader';
            if (this.schedulingForm == null) {
                this.$_emApiMixin_get(_api + '/currentScheduledResult')
                    .then(response => {
                        console.log(response);
                        this.$store.dispatch('calendarShift/collectOriginData', response);
                        this.$store.commit('calendarShift/setLockEventHappened', false);
                        this.initData();
                    }).finally(() => {
                    this.scheduleLoading = false;
                });
            } else {
                this.$_emApiMixin_post(_api + '/scheduling', this.schedulingForm)
                    .then(response => {
                        this.$store.dispatch('calendarShift/collectOriginData', response.data);
                        this.$store.commit('calendarShift/setLockEventHappened', false);
                        this.initData();
                    }).finally(() => {
                    this.scheduleLoading = false;
                });
            }
        },
        saveScheduledResult() {
            let form = this.$refs.scheduleSaveForm.getInputData();
            if (!form) {
                this.$message.warning("请完成填写");
                return;
            }
            this.scheduledResultSaving = true;
            form.version = 1;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdPpHeader/saveScheduledResult',
                data: form
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.scheduledSave.hide();
            }).finally(() => this.scheduledResultSaving = false);
        }
    },
}
</script>

<style scoped>
.cover {
    z-index: 990;
    background-color: black;
    opacity: 0.5;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

.btn-color {
    color: #17a2b8 !important;
    border-color: #17a2b8 !important;
    margin-right: 0.2rem;
}

.btn-color:hover {
    background-color: #17a2b8 !important;
    color: white !important;
}

.drawer-side {
    position: sticky;
    max-width: 100%;
    transition: right .3s ease-out;
}

.display-box {
    display: -webkit-box;
}

.item-open {
}

.item-close {
}

.item-cover {
}

.item-open .item-cover {
    max-height: 120px;
    margin-top: 0.5rem;
    animation: ani-height .3s ease-out;
}

@keyframes ani-height {
    from {
        max-height: 0;
        opacity: 0;
    }
}

.item-close .item-cover {
    max-height: 0;
    opacity: 0;
    margin-top: 0 !important;
    animation: ani-height-cancel .3s ease-out;
}

@keyframes ani-height-cancel {
    from {
        max-height: 120px;
        opacity: 1;
        margin-top: 0.5rem;
    }
}

.trh {
    transition: height .27s ease-out;
}

.item-open .trh {
    height: calc(100vh - 286px);
}

.item-close .trh {
    height: 100%;
}

.loading {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1100;
}

.btn-outline-warning:hover {
    background-color: white;
}
</style>
